<template>
  <SfAccordion>
    <SfAccordionItem
      v-for="item in items"
      :key="item.index"
      :checked="item.checked"
      :current-active-index="effectiveActiveIndex"
      :index="item.index"
      :last="item.last"
      @item-clicked="handleItemClick"
    >
      <template #title>
        {{ item.title }}
      </template>
      <template #description>
        {{ item.description }}
      </template>
      <template #content>
        <component
          :is="item.content?.element"
          :class="item.content?.classNames"
          @click.stop.prevent="handleContentClick(item)"
        >
          {{ item.content?.text }}
          <span
            v-if="item.content?.rightIcon"
            :class="item.content?.rightIcon"
          />
        </component>
      </template>
    </SfAccordionItem>
  </SfAccordion>
</template>
<script setup lang="ts">
import { AdapterCommands } from '@app/shared/vue/composables/types'

import { computed, onBeforeMount } from 'vue'

import SfAccordion from '@app/shared/vue/components/sf-accordion/sf-accordion.vue'
import SfAccordionItem from '@app/shared/vue/components/sf-accordion/sf-accordion-item.vue'
import { useAccordion } from '@app/shared/pinia/accordion'
import getPiniaInstance from '@app/shared/pinia/instance'
import useAdapter from '@app/shared/vue/composables/use-adapter'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfAccordionConnected',
})

type AccordionItem = {
  checked?: boolean
  description: string
  index: string
  last?: boolean
  title: string
  content: {
    classNames?: string
    element: string
    onClickEvent?: AdapterCommands
    text?: string
    rightIcon?: string
  }
}

interface Props {
  accordionId: string
  activeIndex: number
  items: AccordionItem[]
}

const props = defineProps<Props>()

const accordionStore = useAccordion(getPiniaInstance())

onBeforeMount(() => {
  accordionStore.toggleIndex(props.activeIndex.toString(), props.accordionId)
})

const effectiveActiveIndex = computed(() => {
  return accordionStore.accordions[props.accordionId]?.currentAccordionIndex
})

const handleContentClick = (item: AccordionItem) => {
  if (item.content?.onClickEvent) {
    useAdapter(item.content.onClickEvent)
  }
}

const handleItemClick = (index: string) => {
  accordionStore.toggleIndex(index, props.accordionId)
}
</script>
